import { ContentBlockType, CustomComponentBlock } from '../../../model';

export const CUSTOM_COMPONENT_NODE_NAME = 'customComponent';

export const DEFAULT_CUSTOM_COMPONENT_PROPS: Omit<CustomComponentBlock, 'id'> = {
  type: ContentBlockType.CustomComponent,
  component_id: '',
  inputs: {},
};

export const CUSTOM_COMPONENT_MIN_WIDTH = 100;
export const CUSTOM_COMPONENT_MAX_WIDTH = 1200;
export const CUSTOM_COMPONENT_MIN_HEIGHT = 50;
export const CUSTOM_COMPONENT_MAX_HEIGHT = 2000;
